import type { JiraSpaRoute } from '@atlassian/react-resource-router';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

// oxlint-disable-next-line typescript/no-invalid-void-type
export const useRoute: (args_0: void) => JiraSpaRoute = createRouterSelector(
	(state) => state.route,
);
